import { Avatar, AvatarProps } from '@dc-shared-web/components/base/Avatar'
import { FC, ReactNode } from 'react'

export type AvatarGroupProps = {
  /** Array of Avatar components to display. */
  items: ReactNode[]
  /** Maximum number of avatars to show before using the +N overflow indicator. */
  limit: number
  /** Size variant to use for the overflow indicator avatar. This should be the same as the size of the avatars in the items array. */
  fallbackSize: AvatarProps['size']
}

export const AvatarGroup: FC<AvatarGroupProps> = ({
  items,
  limit,
  fallbackSize,
}) => {
  const visibleAvatars = items.slice(0, limit)
  const remainingCount = Math.max(0, items.length - limit)
  const remainingLabel = remainingCount > 9 ? '9+' : `+${remainingCount}`

  return (
    <div className='tw-flex -tw-space-x-2'>
      {visibleAvatars.map((avatar) => avatar)}
      {remainingCount > 0 && (
        <Avatar fallback={remainingLabel} size={fallbackSize} />
      )}
    </div>
  )
}
